module.exports = __webpack_public_path__ + "static/Education3-83e28f946c32ac0e3868b6193d82fe26.png";